import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../redux/core';
import { getRoutesHistorySelector } from '../redux/general/general.selectors';
import { Routes } from '../routes/types';

export const useBack = () => {
  const history = useHistory();
  const historyRoutes = useAppSelector(getRoutesHistorySelector);

  const goBack = useCallback(() => {
    if (historyRoutes.length === 0) {
      history.push(Routes.Home);
    } else {
      history.goBack();
    }
  }, [history, historyRoutes.length]);

  return goBack;
};
